import { Routes } from '@/routes';

export default {
	'broadcast.index': () => import('@/modules/broadcasts/index'),
	'broadcast.new': () => import('@/modules/broadcasts/form'),
	'broadcast.edit': () => import('@/modules/broadcasts/form'),
	'broadcast.review': () => import('@/modules/broadcasts/review'),
} as Routes;
